module.exports = __webpack_public_path__ + "static/media/screenshot_ap_two.148211ed.png";